import { useOKRAccessControl } from 'components/RabbitOKRSidePanel/AccessControl/useOKRAccessControl';
import useOKRConfig from 'components/hooks/useOKRConfig';

import { OBJECTIVE_TYPES_MAP, OKR_PROGRESS_TYPES, OKR_TYPES } from 'constants/ProjectConstants';

export const useCanEditProgressAndStatus = (okrData) => {
  const { type, progressType } = okrData ?? {};

  const { canUpdateOKRStatusAndProgress } = useOKRAccessControl(okrData);
  const { OBJECTIVE_TYPE } = useOKRConfig();

  const isObjective = type === OKR_TYPES.OBJECTIVE;

  const isSimpleObjectiveType = isObjective && OBJECTIVE_TYPE === OBJECTIVE_TYPES_MAP.SIMPLE.value;

  const isCompactObjectiveType = isObjective && OBJECTIVE_TYPE === OBJECTIVE_TYPES_MAP.COMPACT.value;

  /* based on selected tracking type, restrict user from updating achieved, target value */
  const isTrackedByChildren = [OKR_PROGRESS_TYPES.DERIVED_AVG, OKR_PROGRESS_TYPES.DERIVED_SUM].includes(progressType);

  /* is tracked via thirdPartyPlugin */
  const isTrackedByThirdPartyPlugin = [OKR_PROGRESS_TYPES.TRACKED].includes(progressType);

  const cannotEditAchieved =
    !canUpdateOKRStatusAndProgress ||
    isTrackedByChildren ||
    isSimpleObjectiveType ||
    isCompactObjectiveType ||
    isTrackedByThirdPartyPlugin;

  return !cannotEditAchieved;
};
